module.exports = __webpack_public_path__ + "static/media/frame.f68680c2.png";